<div class="icon-input">
   @if (isVisible) {
      <i data-testid="password-input-icon-hide" class="bi bi-eye-slash-fill" (click)="isVisible = false"></i>
   }
   @if (!isVisible) {
      <i data-testid="password-input-icon-show" class="bi bi-eye-fill" (click)="isVisible = true"></i>
   }
   <input data-testid="password-input-field" [type]="isVisible ? 'text' : 'password'" autocomplete="{{autocomplete}}" class="form-control form-control-sm" id="{{id}}" name="{{id}}" [ngModel]="value"
      (ngModelChange)="valueChange.emit($event)" />
</div>
